<ng-template [ngIf]="!viewerMode">
  <dx-report-designer [reportUrl]="reportUrl" height="100vh">
    <dxrd-request-options [getDesignerModelAction]="getDesignerModelAction" [host]="hostUrl"></dxrd-request-options>
    <dxrd-designer-model-settings [allowMDI]="true">
      <dxrd-wizard-settings [useFullscreenWizard]="true" [enableSqlDataSource]="true"></dxrd-wizard-settings>
    </dxrd-designer-model-settings>    
     <dxrd-callbacks (ReportOpened)="onReportOpened($event)"
        (PreviewCustomizeMenuActions)="previewCustomizeMenuActions($event)">
    </dxrd-callbacks>
  </dx-report-designer>
</ng-template>
<ng-template [ngIf]="viewerMode">
  <button class="btn absolute btn-back" (click)="back()">
    <fa-icon [icon]="faArrowLeftLong"></fa-icon>
  </button>
  <dx-report-viewer #viewer [reportUrl]="reportUrl" height="100vh">
    <dxrv-request-options [invokeAction]="//DXXRDV" [host]="hostUrl"></dxrv-request-options>
    <dxrv-callbacks (CustomizeMenuActions)="customizeMenuActions($event)" (DocumentReady)="documentReady()">
    </dxrv-callbacks>
  </dx-report-viewer>
</ng-template>

<ng-template #mySvgTemplate>
  <div (mouseenter)="printButtonHoveredOver = true" (mouseleave)="printButtonHoveredOver = false">
    <ng-template [ngIf]="!printButtonHoveredOver">
      <img title="Print via Print-server" src="../assets/img/printer-plain.png"
        style="width: 50px; height: 50px; transform: translate(-9px, -5px);" class="cursorPointer" />
    </ng-template>
    <ng-template [ngIf]="printButtonHoveredOver">
      <img title="Print via Print-server" src="../assets/img/printer-hover.png"
        style="width: 50px; height: 50px; transform: translate(-9px, -5px);" class="cursorPointer" />
    </ng-template>
  </div>
</ng-template>

<ng-template [ngIf]="showReportPrinting">
  <p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [style]="{width: '25%'}" [baseZIndex]="10000"
    [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false" class="change-scrollbar-color">
    <div class="row sticky dialog-title-container bg-white">
      <div class="col-12 unset-p">
        <div class="flex relative align-centre dialog-title">
          <span class="textGreen font16 b-radius dialog-title-icon bg-light-blue">
            <fa-icon [icon]="faPrint"></fa-icon>
          </span>
          <span class="font17 textBlack">Print via Print Server</span>
          <div class="absolute" style="right: 15px;">
            <span class="textGreen font16 b-radius dialog-title-icon cursorPointer bg-light-blue" (click)="close()">
              <fa-icon [icon]="faXmark"></fa-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row bg-white">
      <div class="flex padding10">
        <div class="col-12 flex unset-p flex align-centre">
          <select #ddl
            class="font14 unset-b padding5 b-radius unset-outline cursorPointer form-select bg-white textBlack"
            (change)="selectPrinter($event)">
            <option class="cursorPointer textBlack" [value]="0">Select printer</option>
            <ng-container *ngFor="let printer of printList">
              <option class="cursorPointer textBlack" [value]="printer.name">
                {{printer.name}} - {{printer.description}} - {{printer.status}}
              </option>
            </ng-container>
          </select>
        </div>
      </div>
    </div>
    <div class="row sticky dialog-footer-container bg-white">
      <div class="col-12 unset-p">
        <div class="flex justify-right padding10 dialog-footer">
          <button class="btn font17" (click)="confirmAndPrint()" [disabled]="!selectedPrinter">
            <fa-icon [icon]="faPrint" class="textGreen"></fa-icon>
            <span class="textBlack">
              Print
            </span>
          </button>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-template>